import { useState } from 'react';

/**
 * Tile 3: Embed Code Snippet UI Mock
 */
const TileEmbedCode = () => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="border border-neutral-200 bg-neutral-50 rounded-lg p-4 space-y-3">
      {/* Code block */}
      <div className="bg-neutral-900 rounded-md p-3 font-mono text-[10px] leading-relaxed overflow-hidden">
        <div className="text-neutral-400">
          <span className="text-pink-400">&lt;script</span>
          <span className="text-sky-300"> src</span>
          <span className="text-neutral-500">=</span>
          <span className="text-amber-300">"bknd.js"</span>
          <span className="text-sky-300"> async</span>
          <span className="text-pink-400">&gt;&lt;/script&gt;</span>
        </div>
        <div className="text-neutral-400 mt-1">
          <span className="text-pink-400">&lt;div</span>
          <span className="text-sky-300"> data-property-id</span>
          <span className="text-neutral-500">=</span>
          <span className="text-amber-300">"12345"</span>
          <span className="text-pink-400">&gt;&lt;/div&gt;</span>
        </div>
      </div>

      {/* Copy button */}
      <button
        type="button"
        onClick={handleCopy}
        className="w-full flex items-center justify-center gap-1.5 text-xs font-medium text-neutral-600 hover:text-neutral-900 py-2 border border-neutral-200 rounded-md bg-white hover:bg-neutral-50 transition-colors"
      >
        {copied ? (
          <>
            <svg className="w-3.5 h-3.5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <span className="text-green-600">Copied!</span>
          </>
        ) : (
          <>
            <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
            </svg>
            <span>Copy code</span>
          </>
        )}
      </button>
    </div>
  );
};

export default TileEmbedCode;
